import TheGrid from '@/views/sales/sellin/grid'

export default {
  path: '/sales/sellin',
  redirect: '/sales/sellin/index',
  name: 'sellin',
  meta: {
    auth: {
      redirect: {
        name: 'sellin.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Sellin'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'sellin.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Vendas'
    }
  }]
}
